import { setAgencyData } from "../mutation-types";
import { SET_AGENCY_DATA } from "../action-types";

const state = {
	agencyData: null
};

export const initialState = Object.assign({}, state);

const actions = {
	[SET_AGENCY_DATA.action]: ({ commit }, payload) => {
		commit(setAgencyData, payload);
	}
};

const mutations = {
	[setAgencyData](state, payload) {
		state.agencyData = payload;
	}
};

export default {
	namespaced: true,
	state,
	actions,
	mutations
};
